/**
 * Created by Vadym Yatsyuk on 31/08/16
 */
export const PLAYER_DIRECTION_UP    = 'up';
export const PLAYER_DIRECTION_DOWN  = 'down';
export const PLAYER_DIRECTION_LEFT  = 'left';
export const PLAYER_DIRECTION_RIGHT = 'right';


// WEBPACK FOOTER //
// ./PlayerDirections.js